// extracted by mini-css-extract-plugin
module.exports = {"Layout":"index2-module--Layout--3bEdW","Content":"index2-module--Content--3n9KR","Header":"index2-module--Header--3coBS"};